import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { ImageAsset } from '../models/image-asset.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class ImageAssetApiService extends ApiService
{
    readonly imageUrls: string[] = [
        'https://smrtscapestorage.blob.core.windows.net/imageassets-shared/stock_controller_image_1w.jpg',
        'https://smrtscapestorage.blob.core.windows.net/imageassets-shared/stock_controller_image_2w.jpg',
        'https://smrtscapestorage.blob.core.windows.net/imageassets-shared/stock_controller_image_3w.jpg',
        'https://smrtscapestorage.blob.core.windows.net/imageassets-shared/stock_controller_image_4w.jpg'
    ];

    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService,
                protected localCacheManager: LocalCacheManager)
    {
        super(http, localCacheManager);
    }

    getImageAsset(imageAssetId: number): Observable<ImageAsset>
    {
        return this.apiRequest(this.apiUrlService.getImageAssetUrl(imageAssetId), this.HttpMethod.Get);
    }

    getImageWithResolution(imageAssetId: number, width: number, height: number): Observable<Blob>
    {
        return this.apiGetRequestForBlob(this.apiUrlService.getImageAssetWithResolutionUrl(imageAssetId, width, height));
    }

    uploadImage(imageFormData: FormData): Observable<any>
    {
        return this.apiRequest(this.apiUrlService.getUploadImageUrl(), this.HttpMethod.Post, imageFormData);
    }

    getControllerImage(): Observable<any>
    {
        let imageIndex = this.localCacheManager.LastControllerImageIndex || this.setInitialControllerImageIndex();
        imageIndex = (imageIndex < this.imageUrls.length - 1) ? ++imageIndex : 0;

        this.localCacheManager.LastControllerImageIndex = imageIndex;

        return this.apiRequestToGetBlobAsFile(this.imageUrls[imageIndex]);
    }

    private setInitialControllerImageIndex(): number
    {
        return Math.floor(Math.random() * this.imageUrls.length);
    }
}
